import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <h1 className="text-4xl font-bold">Page not found</h1>
      <p className="max-w-md text-muted-foreground">
        We couldn't find that page. The quiz link may be from an older build.
      </p>
      <Link
        to="/"
        className="inline-flex h-9 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground shadow-sm transition-opacity hover:opacity-90"
      >
        Go home
      </Link>
    </div>
  );
}